import React, { Component } from 'react'
import { connect } from 'react-redux'

import * as R from 'ramda'
import Moment from 'moment'
import Numeral from 'numeral'

import TextField from 'material-ui/TextField'
import AutoComplete from 'material-ui/AutoComplete';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import dataActions from 'actions/dataActions'
import { doc, dirtyRead } from 'selectors/common'
import { vendors } from 'selectors/entities'
import { transactionEx } from 'selectors/transactions'
import Section from 'components/Section'
import AddLineButton from './AddLineButton'


const catsInvoice = [
	{name: "Rent", req: "#Income:Rent"},
	{name: "Deposit", req: "#Income:Deposit"},
	{name: "Fee", req: "#Income:Fee"},
	{name: "Expenses", req: "#Income:Expenses"}
]

const catsBill = [
	{subtype: "advertising", name: "Advertising", req: "70000 Property Expenses:70010 Advertising"},
	{subtype: "apps", name: "Appliances", req: "70000 Property Expenses:70020 Appliances"},
	{subtype: "cnm", name: "Cleaning and maintenance", req: "70000 Property Expenses:70030 Cleaning and maintenance"},
	{subtype: "hoa", name: "HOA fees", req: "70000 Property Expenses:70040 HOA fees"},
	{subtype: "insurance", name: "Insurance", req: "70000 Property Expenses:70050 Insurance"},
	{subtype: "legal", name: "Legal and Other fees", req: "70000 Property Expenses:70060 Legal and Other fees"},
	{subtype: "management", name: "Management fees", req: "70000 Property Expenses:70070 Management fees"},
	{subtype: "misc", name: "Miscellaneous", req: "70000 Property Expenses:70080 Miscellaneous"},
	{subtype: "loan", name: "Mortgage interest", req: "70000 Property Expenses:70090 Mortgage interest"},
	{subtype: "loan", name: "Mortgage principle", req: "70000 Property Expenses:70100 Mortgage principle"},
	{subtype: "repair", name: "Repair", req: "70000 Property Expenses:70110 Repair"},
	{subtype: "taxes", name: "Taxes", req: "70000 Property Expenses:70120 Taxes"},
	{subtype: "utilities", name: "Utilities", req: "70000 Property Expenses:70130 Utilities"}
]

let select = dirtyRead(
	(state, props) => ({
		transaction: transactionEx(state, props.objectID)
	  , vendors: vendors(state)
	})
)

export class Lines extends Component{
	render(){
		let { props } = this
		let cats = props.transaction.type == "transaction/bill"? catsBill : catsInvoice
		return(
			<Section
				id="transaction/lines"
				title={
					<div>
						<span>Lines </span>
						<span style={{fontWeight: "bold"}}>${Numeral(props.transaction.amount).format('0,00.00')}</span>
					</div>
				}
			>
				{props.transaction.lines && R.map((exp) =>(
					<div>
						<table style={{fontSize: "14px", width: "100%", marginLeft:"-2px"}}><tbody>
							<tr style={{height: "40px", width: "100%"}} >
								<td style={{float: "left", width: "100px"}}>
									<SelectField
										onClick={() => {props.EDIT('transaction/bill')}}
										hintText = {<span>Select category<span style={{color: "#FF0000"}}>*</span></span>}
										hintStyle={{fontStyle: "italic", fontSize: "14px"}}
										underlineStyle={{
											borderBottom: exp.category ? "0px solid" : "2px solid",
											borderColor: exp.category ? "#b0bec4" : "#FD9A41"
										}}
										disabled={true}
										underlineDisabledStyle={{
											borderBottom: exp.category ? "0px solid" : "2px solid",
											borderColor: exp.category ? "#b0bec4" : "#FD9A41"
										}}
										iconStyle={{
											top: "16px"
										  , display: "none"
										}}
										fullWidth={true}
										style={{
											marginTop: "0px"
										  , height:"45px"
										  , color: "black"
										}}
										labelStyle = {{
											display: "table"
										  , textAlign: "left"
										  , color: "black"
										  , fontSize: "14px"
										  , width: "300px"
										  , overflowX: "hidden"
										}}
										inputStyle={{color: "black"}}
										onChange={(evt, indx, value) =>{
											let i = R.indexOf(exp, props.transaction.lines)
											let newExp = {...props.transaction.lines[i], category: value}
											let tmp1 = [
												...props.transaction.lines.slice(0,i)
											  , newExp
											  , ...props.transaction.lines.slice(i+1)
											]
											//console.log(props.transaction.lines)
											//console.log(i)
											props.STAGE({
												_id: props.objectID
											  , lines: tmp1
											})
										}}
										value={props.transaction.lines[R.indexOf(exp, props.transaction.lines)].category || null}
										key={props.transaction.lines[R.indexOf(exp, props.transaction.lines)].category || null}
									>
										{R.map((item) =>
											((item)?
											<MenuItem key={item.req} value={item.name} primaryText={item.name} />
											:
											''
										), cats)
										}
									</SelectField>
								</td>
								<td style={{width: "12px"}}></td>
								<td style={{textAlign: "left"}} onClick={() => {props.EDIT('transaction/bill')}}>
									<TextField
										style={{fontSize: "14px", color: "#000", margin: "0px", color: "black"}}
										fullWidth={true}
										inputStyle={{color: "#000"}}
										underlineStyle={{borderBottom: "0px solid"}}
										underlineDisabledStyle={{borderBottom: "0px solid"}}
										hintText={<span>Line memo</span>}
										hintStyle={{fontSize: "14px", fontStyle: "italic"}}
										disabled={true}
										defaultValue={props.transaction.lines[R.indexOf(exp, props.transaction.lines)].memo}
										key={props.transaction.lines[R.indexOf(exp, props.transaction.lines)].memo}
										onBlur={(evt)=>{
											let i = R.indexOf(exp, props.transaction.lines)
											let newExp = {...props.transaction.lines[i], memo: evt.target.value}
											let tmp1 = [
												...props.transaction.lines.slice(0,i)
											  , newExp
											  , ...props.transaction.lines.slice(i+1)
											]
											props.STAGE({
												_id: props.objectID
											  , lines: tmp1
											})
										}}
									/>
								</td>
								<td style={{width: "80px"}}>
									<TextField
										style={{fontSize: "14px", color: "black", margin: "0px", float: "right",width:"80px", display:"inline-block"}}
										underlineStyle={{
											borderBottom: exp.amount ? "0px solid" : "2px solid",
											borderColor: exp.amount ? "#b0bec4" : "#FD9A41"
										}}
										inputStyle={{color: "#000", textAlign: "right"}}
										disabled={true}
										underlineDisabledStyle={{
											borderBottom: exp.amount ? "0px solid" : "2px solid",
											borderColor: exp.amount ? "#b0bec4" : "#FD9A41"
										}}
										hintText={<span>123.45<span style={{color: "#FF0000"}}>*</span></span>}
										hintStyle={{fontSize: "14px", fontStyle: "italic"}}
										defaultValue={props.transaction.lines[R.indexOf(exp, props.transaction.lines)].amount}
										key={props.transaction.lines[R.indexOf(exp, props.transaction.lines)].amount}
										onBlur={(evt)=>{
											//console.log(exp);
											let newVal = (evt.target.value.match(/^\d+(\.\d+)?$/))?evt.target.value:"0.00"
											let i = R.indexOf(exp, props.transaction.lines)
											let newExp = {...props.transaction.lines[i], amount: Numeral(newVal).format('0.00')}
											let tmp1 = [
												...props.transaction.lines.slice(0,i)
											  , newExp
											  , ...props.transaction.lines.slice(i+1)
											]
											let oldAmount = props.transaction.amount || 0
											let oldExpAmount = (props.transaction.lines[i].amount)?parseFloat(props.transaction.lines[i].amount):0
											let newExpAmount = parseFloat(newVal)
											let newAmount = (props.transaction.lines.length>1)?
													  (oldAmount - oldExpAmount + newExpAmount)
													  :newExpAmount
											props.STAGE({
												_id: props.objectID
											  , lines: tmp1
											  , amount: newAmount
											  , date: props.transaction.date || new Date()
											})
										}}
									/>
								</td>
								<td style={{position:"relative", left:"-1px", width: "30px", textAlign:"right"}}>
									<div style={{width: "30px", textAlign:"right"}}>
										<img src="/landlord/static/img/trash-red.png"
											style={{
												height: "16px"
											  , cursor: !props.transaction.qbid ? "pointer" : "not-allowed"
											  , marginLeft: "5px"
											  , display: (props.transaction.lines.length>1)?"":"none"
											}}
											onClick={()=> {
												if (!!props.transaction.qbid) return
												let i = R.indexOf(exp, props.transaction.lines)
												let newAmount = props.transaction.amount - props.transaction.lines[i].amount
												let curExp = [
													...props.transaction.lines.slice(0,i)
												  , ...props.transaction.lines.slice(i+1)
												]
												// for (var i = 0; i < curExp.length; i++) {
												// 	curExp[i].num =  i
												// }
												props.STAGE({
													_id: props.objectID
												  , lines: curExp
												  , amount: newAmount
											  })
											}}
										/>
									</div>
								</td>
							</tr>
						</tbody></table>
						</div>
					), props.transaction.lines)}

						{props.transaction.expenses && R.map((exp) =>(
					        <table style={{fontSize: "14px", width: "calc(100% + 0px)", marginLeft:"-2px"}}><tbody>
					            <tr  style={{height: "40px"}}>
					                <td style={{textAlign: "left", width: "100px"}}>
					                    <SelectField
					                        hintText = {<span>Select category<span style={{color: "#FF0000"}}>*</span></span>}
					                        hintStyle={{fontStyle: "italic", fontSize: "14px"}}
					                        underlineStyle={{
					                            borderBottom: exp.category ? "0px solid" : "2px solid",
					                            borderColor: exp.category ? "#b0bec4" : "#FD9A41"
					                        }}
					                        disabled={true}
					                        fullWidth={true}
					                        underlineDisabledStyle={{
					                            borderBottom: exp.category ? "0px solid" : "2px solid",
					                            borderColor: exp.category ? "#b0bec4" : "#FD9A41"
					                        }}
					                        iconStyle={{
					                            top: "16px"
											  , display: "none"
					                        }}
											style={{
					                            margin: "0px"
											  , width: "200px"
											  , height:"45px"
											  , overflow: "hidden"
											  , color: "black"
					                        }}
											labelStyle={{
					                            color: "black"
					                        }}
											menuStyle={{
					                            margin: "0px"
											  , color: "black"
											  , width: "250px"
											  , overflow: "hidden"
					                        }}
					                        onChange={(evt, indx, value) =>{
					                            let i = R.indexOf(exp, props.transaction.expenses)
					                            let newExp = {...props.transaction.expenses[i], category: value}
					                            let tmp1 = [
					                                ...props.transaction.expenses.slice(0,i)
					                              , newExp
					                              , ...props.transaction.expenses.slice(i+1)
					                            ]
					                            //console.log(props.transaction.expenses)
					                            //console.log(i)
					                            props.STAGE({
					                                _id: props.objectID
					                              , expenses: tmp1
					                            })
					                        }}
											key ={props.transaction.expenses[R.indexOf(exp, props.transaction.expenses)].category}
					                        value={props.transaction.expenses[R.indexOf(exp, props.transaction.expenses)].category}
					                    >
					                        {R.map((item) =>
					                            ((item)?
					                            <MenuItem key={item.req} value={item.req} primaryText={item.name} />
					                            :
					                            ''
					                            ), cats)
					                        }
					                    </SelectField>
					                </td>
					                <td style={{width: "12px"}}></td>
					                <td style={{textAlign: "left"}}>
					                    <TextField
					                        style={{fontSize: "14px", color: "#000", margin: "0px", color: "black"}}
					                        fullWidth={true}
					                        inputStyle={{color: "#000"}}
					                        underlineStyle={{borderBottom: "0px solid"}}
					                        disabled={true}
					                        underlineDisabledStyle={{borderBottom: "0px solid"}}
					                        hintText={<span>Line memo</span>}
					                        hintStyle={{fontSize: "14px", fontStyle: "italic"}}
					                        defaultValue={props.transaction.expenses[R.indexOf(exp, props.transaction.expenses)].memo}
					                        key={props.transaction.expenses[R.indexOf(exp, props.transaction.expenses)].memo}
					                        onBlur={(evt)=>{
					                            let i = R.indexOf(exp, props.transaction.expenses)
					                            let newExp = {...props.transaction.expenses[i], memo: evt.target.value}
					                            let tmp1 = [
					                                ...props.transaction.expenses.slice(0,i)
					                              , newExp
					                              , ...props.transaction.expenses.slice(i+1)
					                            ]
					                            props.STAGE({
					                                _id: props.objectID
					                              , expenses: tmp1
					                            })
					                        }}
					                    />
					                </td>
					                <td style={{float:"right", width: "80px"}}>
					                    <TextField
					                        style={{fontSize: "14px", color: "black", margin: "0px", float: "right",width:"80px", display:"inline-block"}}
					                        underlineStyle={{
					                            borderBottom: exp.amount ? "0px solid" : "2px solid",
					                            borderColor: exp.amount ? "#b0bec4" : "#FD9A41"
					                        }}
					                        inputStyle={{color: "#000", textAlign: "right"}}
					                        disabled={true}
					                        underlineDisabledStyle={{
					                            borderBottom: exp.amount ? "0px solid" : "2px solid",
					                            borderColor: exp.amount ? "#b0bec4" : "#FD9A41"
					                        }}
					                        hintText={<span>123.45<span style={{color: "#FF0000"}}>*</span></span>}
					                        hintStyle={{fontSize: "14px", fontStyle: "italic"}}
					                        defaultValue={props.transaction.expenses[R.indexOf(exp, props.transaction.expenses)].amount}
					                        key={props.transaction.expenses[R.indexOf(exp, props.transaction.expenses)].amount}
					                        onBlur={(evt)=>{
					                            //console.log(exp);
					                            let newVal = (evt.target.value.match(/^\d+(\.\d+)?$/))?evt.target.value:"0.00"
					                            let i = R.indexOf(exp, props.transaction.expenses)
					                            let newExp = {...props.transaction.expenses[i], amount: Numeral(newVal).format('0.00')}
					                            let tmp1 = [
					                                ...props.transaction.expenses.slice(0,i)
					                              , newExp
					                              , ...props.transaction.expenses.slice(i+1)
					                            ]
					                            let oldAmount = props.transaction.amount || 0
					                            let oldExpAmount = (props.transaction.expenses[i].amount)?parseFloat(props.transaction.expenses[i].amount):0
					                            let newExpAmount = parseFloat(newVal)
					                            let newAmount = (props.transaction.expenses.length>1)?
					                                      (oldAmount - oldExpAmount + newExpAmount)
					                                      :newExpAmount
					                            props.STAGE({
					                                _id: props.objectID
					                              , expenses: tmp1
					                              , amount: newAmount
					                              , date: props.transaction.date || new Date()
					                            })
					                        }}
					                    />
					                </td>
					            </tr>
					        </tbody></table>), props.transaction.expenses)}

                </Section>
		)
	}
}

export default connect(select, dataActions)(Lines)



// WEBPACK FOOTER //
// ./src/routes/landlord/transactionForm/Lines.js